import { getAssetUrl } from '@lighthouse/assets'
import { IconFont } from '@lighthouse/bui'
import type { FieldInputType, FieldType } from '@lighthouse/core'
import { FIELD_TYPE_LIMIT_ENUM, FILE_TYPE_CATEGORY_ENUM } from '@lighthouse/core'
import { inputTypeEventMap } from '@lighthouse/shared'
import React from 'react'

const displayListSvg = getAssetUrl('common', 'display_list.svg')
const displayTableSvg = getAssetUrl('common', 'display_table.svg')

export const VIEW_DATASOURCE_OPTIONS = [
    { label: '以表格方式显示', value: 'table', icon: displayTableSvg },
    { label: '以列表方式显示', value: 'list', icon: displayListSvg }
]

export const READONLY_FIELDS: FieldType[] = ['id', 'aggregation']

export const SHOW_MODE_OPTIONS = [
    { label: '下拉框', value: 'input' },
    { label: '平铺', value: 'tag' },
    { label: '选框', value: 'checkbox' }
]

export const DIRECTION_OPTIONS = [
    { label: '横向', value: 'horizontal' },
    { label: '纵向', value: 'vertical' }
]

export const ALIGN_OPTIONS = [
    { label: '居左', value: 'left' },
    { label: '居中', value: 'center' },
    { label: '居右', value: 'right' }
]

export const DATE_RANGE_OPTIONS = [
    { label: '所有时间', value: 'ALL' },
    { label: '今天及以前', value: 'BEFORE_TODAY' },
    { label: '今天及以后', value: 'AFTER_TODAY' },
    { label: '多少天以后', value: 'AFTER_CUSTOM' }
]

export const CALENDAR_RANGE_OPTIONS = [...DATE_RANGE_OPTIONS, { label: '按照日期字段匹配', value: 'DATASOURCE_CUSTOM' }]

export const scannerOptions = [
    { label: '条形码', value: 'barCode' },
    { label: '二维码', value: 'qrCode' }
]

export const imageSourceOptions = [
    { label: '禁止手动输入', value: 'input' },
    { label: '禁用相册', value: 'album' }
]

export const FieldInputDescMap: Record<FieldInputType, string> = {
    text: '只可选「文本类」字段',
    number: '只可选「数值」字段',
    email: '只可选「文本类」字段',
    phoneNumber: '只可选「文本类」字段',
    url: '只可选「文本类」字段',
    // select: '选项',
    date: '只可选「日期」或 「文本类」字段',
    file: '只可选「附件」字段',
    notes: '只可选「笔记」字段',
    relativeSelect: '只可选「选项」、「数值」或「文本类」字段',
    person: ' 只可选「人员」字段',
    checkbox: '只可选「复选框」字段',
    slider: '只可选「数值」字段',
    cascade: '只可选「文本类」字段',
    calendar: '只可选「日期」或 「文本类」字段'
}

export const inputHeightOptions = [
    { icon: <IconFont type="InputHeightS" color="var(--color-gray-400)" />, value: 'small' },
    { icon: <IconFont type="InputHeightM" color="var(--color-gray-400)" />, value: 'middle' },
    { icon: <IconFont type="InputHeightL" color="var(--color-gray-400)" />, value: 'large' }
]

export const relativeSelectFieldList = new Set<FieldType>(['select', 'singleSelect'])

export const EVENTS_ENTER_FIELDS = new Set<FieldInputType>(['email', 'number', 'phoneNumber', 'text', 'url'])

export const EVENTS_FIELDS = new Set(
    Object.entries(inputTypeEventMap)
        .filter(([, item]) => item.length > 0)
        .map(([key]) => key)
)

export const FILE_TYPE_CATEGORY_OPTIONS = [
    { label: '图片', value: FILE_TYPE_CATEGORY_ENUM.IMAGE },
    { label: '文档', value: FILE_TYPE_CATEGORY_ENUM.DOCUMENT },
    { label: '音频', value: FILE_TYPE_CATEGORY_ENUM.AUDIO },
    { label: '视频', value: FILE_TYPE_CATEGORY_ENUM.VIDEO }
]

export const FILE_LIMIT_TYPE_OPTIONS = [
    { label: '不限', value: FIELD_TYPE_LIMIT_ENUM.ALL },
    { label: '类型', value: FIELD_TYPE_LIMIT_ENUM.TYPE },
    { label: '后缀', value: FIELD_TYPE_LIMIT_ENUM.SUFFIX }
]
